import { Toro } from '../common/enumerations';
import { ActiveProgramInfo } from './active-program-info.model';
import { ActiveStationInfo } from './active-station-info.model';
import RunningStatus = Toro.RunningStatus;

export class ActiveControllerInfo
{
    constructor(json: any = null)
    {
        if (json)
        {
            Object.assign(this, json);

            if (json.RunningPrograms)
            {
                const runningPrograms = [];
                json.RunningPrograms.forEach(runningProgram => { runningPrograms.push(new ActiveProgramInfo(runningProgram)); });
                this.RunningPrograms = runningPrograms;
            }

            if (json.RunningStations)
            {
                const runningStations = [];
                json.RunningStations.forEach(runningStation => { runningStations.push(new ActiveStationInfo(runningStation)); });
                this.RunningStations = runningStations;
            }
        }
    }

    ControllerId = -1;
    RunningPrograms: ActiveProgramInfo[] = [];
    RunningStations: ActiveStationInfo[] = [];

    public getActiveProgramNumber()
    {
        let activeProgramNumber = -1;
        for (let i = 0; i < this.RunningPrograms.length; i++)
        {
            if (this.RunningPrograms[i].RunningProgramStatus === RunningStatus.Running ||
                this.RunningPrograms[i].RunningProgramStatus === RunningStatus.Soaking)
            {
                activeProgramNumber = this.RunningPrograms[i].RunningProgramNumber;
                break;
            }
        }
        return activeProgramNumber;
    }

    public getActiveProgram(programNumber: number): ActiveProgramInfo
    {
        return this.RunningPrograms.find(runningProgram => runningProgram.RunningProgramNumber === programNumber);
    }

    public getActiveStationNumber()
    {
        let activeStationNumber = -1;
        for (let i = 0; i < this.RunningStations.length; i++)
        {
            if (this.RunningStations[i].RunningStationRemainingSeconds === 0)
            {
                continue;
            }
            if (this.RunningStations[i].RunningStationStatus === RunningStatus.Running)
            {
                activeStationNumber = this.RunningStations[i].RunningStationNumber;
                break;
            }
            if (this.RunningStations[i].RunningStationStatus === RunningStatus.Soaking && activeStationNumber === -1)
            {
                activeStationNumber = this.RunningStations[i].RunningStationNumber;
                break;
            }
        }
        // for (const runningStation: ActiveStationInfo in this.RunningStations)
        // {
        //     if (runningStation.RunningStationRemainingSeconds === 0)
        //     {
        //         continue;
        //     }
        //     if (runningStation.RunningStationStatus === RunningStatus.Running)
        //     {
        //         activeStationNumber = runningStation.RunningStationNumber;
        //         break;
        //     }
        //     if (runningStation.RunningStationStatus === RunningStatus.Soaking && activeStationNumber === -1)
        //     {
        //         activeStationNumber = runningStation.RunningStationNumber;
        //         break;
        //     }
        // }
        return activeStationNumber;
    }

    public getActiveStation(stationNumber): ActiveStationInfo
    {
        return this.RunningStations.find(runningStation => runningStation.RunningStationNumber === stationNumber);
    }
}
